import { useState, useEffect, useRef } from 'react'

type UseMobileCloseButtonProps = Readonly<{
  onClose?: () => void
  onClick?: () => void
}>

export const useMobileCloseButton = ({ onClose, onClick }: UseMobileCloseButtonProps) => {
  const [showCloseOnMobile, setShowCloseOnMobile] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  // Handle clicks outside to hide close button on mobile
  useEffect(() => {
    if (!onClose) return

    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setShowCloseOnMobile(false)
      }
    }

    if (showCloseOnMobile) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose, showCloseOnMobile])

  const handleMobileClick = () => {
    if (!showCloseOnMobile) {
      // First tap: show close button
      setShowCloseOnMobile(true)
    } else {
      // If close button is already shown, call onClick if provided
      onClick?.()
    }
  }

  const handleCloseClick = () => {
    onClose?.()
    setShowCloseOnMobile(false)
  }

  return {
    showCloseOnMobile,
    containerRef,
    handleMobileClick,
    handleCloseClick
  }
}